import {Sine, TweenLite} from "gsap";
import {Container} from "../Core/Container";
import {Assets} from "../Data/Assets";
import {ICaptionRenderer} from "../Managers/CaptionManager";
import {Timedline} from "springroll";
import {Environment} from "../Data/Environment";
import {VoiceOverManager} from "../Managers/VoiceOverManager";

export class DefaultCaptionRenderer extends Container implements ICaptionRenderer {

    private readonly _bg: PIXI.Sprite;
    private readonly _text: PIXI.BitmapText;
    private _textTween?: TweenLite;
    private _bgTween?: TweenLite;
    private readonly _size = new PIXI.Point();

    constructor() {
        super();

        this._bg = new PIXI.Sprite(PIXI.Texture.WHITE);
        this._bg.anchor.set(0.5, 0);
        this._bg.height = 60;
        this._bg.tint = 0x000000;
        this._bg.alpha = 0;
        this.addChild(this._bg);

        this._text = new PIXI.BitmapText("", {
            fontName: Assets.fontGelPenUpright.assetName,
            fontSize: 100,
            align: "center",
        });
        this._text.alpha = 0;
        this._text.visible = false;
        this._text.anchor = new PIXI.Point(0.5, 0.5);
        this.addChild(this._text);

        if (!Environment.isLive()) {
            let isTapping = false;
            this._bg.interactive = true;
            this._bg.on("pointertap", () => {
                if (isTapping) {
                    return;
                }
                isTapping = true;
                setTimeout(() => {
                    isTapping = false;
                    VoiceOverManager.instance.stopVO();
                }, 100);
            });
        }
    }

    public start(): void {
        this._text.visible = true;
        this._bg.visible = true;
        this.killTween(this._textTween);
        this.killTween(this._bgTween);
        this._textTween = new TweenLite(this._text, 0.25, {
            alpha: 1,
            ease: Sine.easeInOut,
        });
        this._bgTween = new TweenLite(this._bg, 0.15, {
            alpha: 0.6,
            ease: Sine.easeInOut,
        });
    }

    public stop(): void {
        this.killTween(this._textTween);
        this.killTween(this._bgTween);
        this._textTween = new TweenLite(this._text, 0.25, {
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: () => {
                this._text.visible = false;
            },
        });
        this._bgTween = new TweenLite(this._bg, 0.25, {
            delay: 0.25,
            alpha: 0,
            ease: Sine.easeInOut,
            onComplete: () => {
                this._bg.visible = false;
            },
        });
    }

    public lineBegin(line: Timedline): void {
        let text = line.content
            .replace(/<[^>]*>/ig, "") // remove html tags
            .replace(/\[.*][^\w]*/ig, ""); // remove brackets
        if (line.startTime === 0) {
            text = text.charAt(0).toUpperCase() + text.slice(1);
        }
        this._text.text = text;
        this.onResize(this._size);
    }

    public lineEnd(): void {
        // no implementation
    }

    public onResize(pSize: PIXI.Point): void {
        this._size.x = pSize.x;
        this._size.y = pSize.y;

        this._bg.width = this._size.x;
        this._bg.position.set(this._size.x * 0.5, 0);

        this._text.maxWidth = 2000;
        this._text.scale.set(0.5);
        this._text.position.set(
            this._size.x * 0.5,
            this._bg.height * 0.55,
        );
    }

    private killTween(pTween: TweenLite | undefined): void {
        if (pTween !== undefined) {
            pTween.kill();
        }
    }
}
